import { createEntityReducer } from 'ext/lib/collections';
import { TYPE } from './actions';

export default createEntityReducer(TYPE);

export const selectUser = state => state[TYPE];
